var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "tabs-content boss-tabs-content-job-selected",
      attrs: {
        "data-tabs-content": "boss-tabs-control-" + _vm.suffix,
        "data-test": "control",
      },
    },
    _vm._l(_vm.masterData, function (categories, index) {
      return _c("select-modal-contents-categories", {
        key: index,
        staticClass: "tabs-panel boss-tabs-panel",
        attrs: {
          suffix: _vm.suffix,
          "categories-data-map": _vm.masterDataMap[categories.id],
          categories: categories,
          depth: _vm.depth,
          "experience-range-options": _vm.experienceRangeOptions,
          "default-experience-id": _vm.defaultExperienceId,
          "is-active": index === 0,
          "can-accordion": _vm.canAccordion,
        },
        on: { "update-categories": _vm.updateCategories },
      })
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }